import React from 'react';
import { AnalyticsCard } from 'src/pages/AnalyticsPage/AnalyticsCustomer/AnalyticsCard/AnalyticsCard';
import { AnalyticsCustomerPopup } from 'src/pages/AnalyticsPage/AnalyticsCustomer/AnalyticsCustomerPopup/AnalyticsCustomerPopup';
import {
  DateItemsGroupByX,
  DateItemsGroupByY,
} from 'src/pages/AnalyticsPage/AnalyticsCustomer/DateItems';
import { cardMetric, cardTitle } from '../utils/metricFormatters';
import { DateRangeItem, MetricValue } from '../AnalyticsCoCustomer.types';

const POPUP_COLOR = '#5D4EC7';

type SpeedCardConfig = {
  key: string;
  title: string;
  metric: MetricValue;
  tooltip?: React.ReactNode;
  popupDataKey?: string;
};

type SpeedEfficiencySectionProps = {
  dateRange: DateRangeItem;
  firstResponseTimeAvg: MetricValue;
  responseTimeAvg: MetricValue;
  resolutionTimeAvg: MetricValue;
};

export const SpeedEfficiencySection = ({
  dateRange,
  firstResponseTimeAvg,
  responseTimeAvg,
  resolutionTimeAvg,
}: SpeedEfficiencySectionProps) => {
  const cards: SpeedCardConfig[] = [
    {
      key: 'firstResponseTimeAvg',
      title: 'First response time average',
      metric: firstResponseTimeAvg,
    },
    {
      key: 'responseTimeAvg',
      title: 'Response time average',
      metric: responseTimeAvg,
      popupDataKey: 'responseTimeAvg',
      tooltip: (
        <span>
          Average time between a customer message and the AI&apos;s reply across all messages
        </span>
      ),
    },
    {
      key: 'resolutionTimeAvg',
      title: 'Resolution time average',
      metric: resolutionTimeAvg,
      popupDataKey: 'resolutionTimeAvg',
      tooltip: <span>Average time from when a ticket is opened until it is fully resolved</span>,
    },
  ];

  return (
    <div className={'flex flex-row w-full flex-wrap md:gap-[10px] gap-[6px]'}>
      {cards.map(({ key, title, metric, tooltip, popupDataKey }) => (
        <div className={'flex flex-1 min-w-[220px]'} key={key}>
          <AnalyticsCard
            title={cardTitle(title)}
            metric={cardMetric(metric.value)}
            toolTipDescription={tooltip}
            icon={
              popupDataKey && (
                <AnalyticsCustomerPopup
                  title={title}
                  dateRange={dateRange}
                  color={POPUP_COLOR}
                  dataKey={popupDataKey}
                  chartType={'lineChart'}
                  className={'bg-[#F1F8FF]'}
                  xAxisSelect={DateItemsGroupByX}
                  yAxisSelect={DateItemsGroupByY}
                />
              )
            }
          />
        </div>
      ))}
    </div>
  );
};
